import classNames from 'classnames';
import React from 'react';
import { FCC } from 'react';
import { IButtonProps } from './types';

import './Button.scss';

export const Button: FCC<IButtonProps> = (props) => {
  const {
    type = 'submit',
    label,
    color = 'default',
    onClick,
    disabled,
    href = '',
    size = '',
    title = '',
    style = {},
  } = props;
  const buttonTypes = ['primary', 'success', 'info', 'warning', 'danger', 'default', 'secondary', 'cancel', 'link'];
  const buttonClasses = classNames({
    btn: true,
    [`btn-${color}`]: !!(color && buttonTypes.indexOf(color) !== -1),
    [`btn-${size}`]: !!size,
  });

  const styles = {
    backgroundColor: color && buttonTypes.indexOf(color) === -1 ? color : '',
    ...style,
  };

  const Tag = href ? 'a' : 'button';
  const extraProps = href ? { role: 'button', href } : { type };

  return (
    <Tag
      className={buttonClasses}
      style={styles}
      onClick={onClick}
      disabled={disabled}
      {...extraProps}
      qa-id={props['qa-id']}
      title={title}
    >
      {label}
    </Tag>
  );
};

export default Button;
